/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import axios from 'axios';
import apiConfig from "../../config/apiConfig";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";


// reactstrap components
import { Nav, NavLink as ReactstrapNavLink } from "reactstrap";
import {
  BackgroundColorContext,
  backgroundColors,
} from "contexts/BackgroundColorContext";

var ps;

function Sidebar(props) {
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  const [countMessage, setCountMessage] = React.useState();
  const [countMessageSubApp, setCountMessageSubApp] = React.useState();
  const serverUrl = apiConfig.serverUrl;
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  // تعداد پیام‌ها (عدد ثابت برای مثال)


  // استایل نشانگر پیام‌ها
  const badgeStyle = (countMessage) => {
    const size = Math.max(20, countMessage.toString().length * 10); // حداقل اندازه 20px و افزایش به ازای هر رقم
    return {
      backgroundColor: "rgb(193 83 237)",
      color: "white",
      borderRadius: "50%",
      fontSize: "12px",
      width: `${size}px`, // عرض متناسب با طول عدد
      height: `${size}px`, // ارتفاع برابر با عرض
      display: "flex",
      alignItems: "center", // ترازبندی عمودی
      justifyContent: "center", // ترازبندی افقی
      position: "absolute",
      top: "0",
      left: "0",
    };
  };
  

  
  React.useEffect(() => {
  

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };

  
  });

  React.useEffect(() => {
  
    axios
    .get(serverUrl + "get-all-count-tickets-panel")
    .then((response) => {
      
      setCountMessage(response.data.count_message); 
      setCountMessageSubApp(response.data.count_message_subapp); 
     
    })
    .catch((error) => {
      console.error("خطا در دریافت اطلاعات:", error);
     
    });

  
  },[countMessage]);

  const calculateUnreadMessages = () => {
    
   
    const messagesForTicket = ticketMessages.find(
      (messages) => messages.some((msg) => msg.status == "not_seen")
    );
    

    // اگر پیام‌هایی برای تیکت وجود داشته باشد، تعداد پیام‌های خوانده‌نشده را محاسبه می‌کنیم
    if (messagesForTicket) {
      return messagesForTicket.filter((msg) => msg.status === "not_seen")
        .length;
    }
    
    // اگر پیام‌ها برای تیکت پیدا نشد، مقدار 0 را برمی‌گردانیم
    return 0;
  };
  const linkOnClick = () => {
    document.documentElement.classList.remove("nav-open");
  };
  const { routes, rtlActive, logo } = props;
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a
          href={logo.outterLink}
          className="simple-text logo-mini"
          target="_blank"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </a>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          target="_blank"
          onClick={props.toggleSidebar}
        >
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </Link>
      );
      logoText = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.toggleSidebar}
        >
          {logo.text}
        </Link>
      );
    }
  }
  
  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="sidebar" data={color}>
          <div className="sidebar-wrapper" ref={sidebarRef}>
            {logoImg !== null || logoText !== null ? (
              <div className="logo">
                {logoImg}
                {logoText}
              </div>
            ) : null}
            <Nav>
              {routes.map((prop, key) => {
                
                const isMessagesMenu = prop.name === "صندوق پیام مشاوره"; 
                const isMessagesMenu2 = prop.name === "صندوق پیام رژیم"; 
                
                if (prop.redirect || key > 9 ) return null;
                return (
                  <li
                    className={
                      activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className="nav-link"
                      onClick={props.toggleSidebar}
                    >
                      <i className={prop.icon} />
                      <p style={{ position: "relative" }}>
                        {rtlActive ? prop.rtlName : prop.name}
                        {isMessagesMenu && countMessageSubApp > 0 && (
                          <span style={badgeStyle(countMessageSubApp)}>{countMessageSubApp}</span>
                        )}

                        {isMessagesMenu2 && countMessage > 0 && (
                          <span style={badgeStyle(countMessage)}>{countMessage}</span>
                        )}
                        
                      </p>
                    </NavLink>
                  </li>
                );
              })}
              
            </Nav>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the text of the logo
    text: PropTypes.node,
    // the image src of the logo
    imgSrc: PropTypes.string,
  }),
};

export default Sidebar;
